import React, { useCallback, useEffect, useState } from "react";

import { Button, Dropdown, Form, Input, Menu, Modal, PageHeader, Select, Table, Tag } from "antd";
import { crud } from "@/redux/crud/actions";
import { useDispatch, useSelector } from "react-redux";
import { selectItemById, selectListItems, selectUpdatedItem } from "@/redux/crud/selectors";
import { CheckOutlined, CloseOutlined, DeleteOutlined, EditOutlined, EllipsisOutlined, EyeOutlined } from "@ant-design/icons";
import { Link, Redirect, useHistory } from "react-router-dom";
import { Switch } from 'antd';
import uniqueId from "@/utils/uinqueId";
import SearchItem from "@/components/SearchItem";
import HeaderContent from "@/layout/HeaderContent";
import Loading from "@/components/Loading";
import { API_BASE_URL } from "@/config/serverApiConfig";
import axios from "axios";
import TextArea from "antd/lib/input/TextArea";

function ListingRequest() {
    const entity = "request-listing";
    const searchConfig = {
        // displayLabels: ["fname", "lname", "email"],
        displayLabels: ["email"],
        searchFields: "fname,lname,email",
        outputValue: "_id",
    };

    let [note, setNote] = useState("");
    const { current, isLoading, isSuccess } = useSelector(selectUpdatedItem);
    const [loadForm, setLoadForm] = useState(true)
    const [loadFormView, setLoadFormView] = useState(true)
    const dispatch = useDispatch();
    const [disabled, setDisabled] = useState(false);
    const [deactiveData, setDeactiveData] = useState({});


    let [data, setData] = useState([]);

    let [edit_id, set_edit_id] = useState(0);
    const [visible, setVisible] = useState(false);
    const [visibleView, setVisibleView] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [confirmLoadingView, setConfirmLoadingView] = useState(false);
    const [modalText, setModalText] = useState('Content of the modal');
    const [form] = Form.useForm();

    let history = useHistory();
    const panelTitle = "Request Directory List ";
    const dataTableTitle = "Request Directory List";
    const entityDisplayLabels = ["company"];

    const { result: listResult, isLoading: listIsLoading } = useSelector(
        selectListItems
    );
    const { pagination, items } = listResult;

    const [isModalVisible, setIsModalVisible] = useState(false);
    const ADD_NEW_ENTITY = "View Pending Approval User";
    const DATATABLE_TITLE = "Business Directory List";
    const ENTITY_NAME = "Business Directory";
    const CREATE_ENTITY = "Create Business Directory";
    const UPDATE_ENTITY = "Update Business Directory";

    const approve = (data) => {
        
        data.row.status = true
        data.row.approval_status = true
        data.row.category_id_one = data.row.category_id_one ? data.row.category_id_one._id : null
        data.row.category_id_two = data.row.category_id_two ? data.row.category_id_two._id : null
        data.row.category_id_three = data.row.category_id_three ? data.row.category_id_three._id : null
        dispatch(crud.update(entity, data.row._id, data.row))
            .then(res => {
                dispatch(crud.list(entity, pagination.current));
            })
            .catch(err => {
            
            })
            ;
    }

    const disApprove = () => {
        
        
        console.log(deactiveData)
        deactiveData.user_id = deactiveData.user_id._id
        deactiveData.category_id_one = deactiveData.category_id_one ? deactiveData.category_id_one._id : null
        deactiveData.category_id_two = deactiveData.category_id_two ? deactiveData.category_id_two._id : null
        deactiveData.category_id_three = deactiveData.category_id_three ? deactiveData.category_id_three._id : null

        // data.status = false
        deactiveData.status = false
        deactiveData.note = note;
        deactiveData.approval_status = true;
        dispatch(crud.update(entity, deactiveData._id, deactiveData))
            .then(res => {
                dispatch(crud.list(entity, pagination.current));
                setIsModalVisible(false);
            })
            .catch(err => {
               
                
            })
            ;
    }
    
    const readColumns = [
        {
            title: "User",
            dataIndex: "user_id",
        },
        {
            title: "Category 1",
            dataIndex: "category_id_one",
        },

        {
            title: "Category 2",
            dataIndex: "category_id_two",
        },
        {
            title: "Category 3",
            dataIndex: "category_id_three",
        },

    ];

    const dataTableColumns = [
        {
            title: "User",
            render: (row) => {
                return (
                    <>
                        <p>{(row.user_id && row.user_id.fname) ? row.user_id.fname : ""} {(row.user_id && row.user_id.lname) ? row.user_id.lname : ""}</p>
                        {/* <Switch size="small" defaultChecked disabled={disabled} onChange={() => onChangeSwitch({ row })} /> */}
                    </>
                );
            }
        },
        {
            title: "Category 1",
            render: (row) => {
                return (
                    <>
                        <p>{row.category_id_one ? row.category_id_one.name : ""}</p>
                        {/* <Switch size="small" defaultChecked disabled={disabled} onChange={() => onChangeSwitch({ row })} /> */}
                    </>
                );
            }
            // dataIndex: "category_id_one",
        },

        {
            title: "Category 2",
            render: (row) => {
                if (row.category_id_two && row.category_id_two.name) {

                    return (
                        <>
                            <p>{row.category_id_two && row.category_id_two.name ? row.category_id_two.name : ""}</p>
                            {/* <Switch size="small" defaultChecked disabled={disabled} onChange={() => onChangeSwitch({ row })} /> */}
                        </>
                    );
                }
            }
        },
        {
            title: "Category 3",
            render: (row) => {
                if (row.category_id_three && row.category_id_three.name) {

                    return (
                        <>
                            <p>{row.category_id_three.name}</p>
                            {/* <Switch size="small" defaultChecked disabled={disabled} onChange={() => onChangeSwitch({ row })} /> */}
                        </>
                    );
                }
            }
        },
        {
            title: "Approval Status",
            render: (row) => {

                if (row && row.status) {
                    return (
                        <>
                            <Tag color="green" >
                                Approved
                            </Tag>
                            {/* <Button type="primary" size="small" disabled>Approved</Button> */}
                            {/* <Switch size="small" defaultChecked disabled={disabled} onChange={() => onChangeSwitch({ row })} /> */}
                        </>
                    );
                }
                else if (row && ('note' in row) && row.status == false) {
                    return (
                        <>
                            <Tag color="red" >
                                Disapproved
                            </Tag>
                            {/* <Button type="primary" size="small" disabled>Disapproved</Button> */}
                            {/* <Switch size="small" defaultChecked disabled={disabled} onChange={() => onChangeSwitch({ row })} /> */}
                        </>
                    );
                }
                else {
                    return (
                        <>
                            <Button type="primary" icon={<CheckOutlined />} size="small" onClick={() => approve({ row })}>Approve</Button>
                            <Button type="primary" icon={<CloseOutlined />} danger size="small" onClick={() => showModalNote({ row })}>Disapprove</Button>
                        </>
                    );

                }

            }
        },
        // {
        //     title: "",
        //     render: (row) => (

        //         <Dropdown overlay={DropDownRowMenu({ row })} trigger={["click"]}>
        //             <EllipsisOutlined style={{ cursor: "pointer", fontSize: "24px" }} />
        //         </Dropdown>
        //     ),
        // },

    ];

    const onChangeSwitch = ({ row }) => {
        row.status = true;
        dispatch(crud.update(entity, row._id, row));
    }

    const handelDataTableLoad = useCallback((pagination) => {
        dispatch(crud.list(entity, pagination.current));
    }, []);

    function DropDownRowMenu({ row }) {
        // const dispatch = useDispatch();
        // const { crudContextAction } = useCrudContext();
        // const { panel, collapsedBox, modal, readBox, editBox } = crudContextAction;
        // const item = useSelector(selectItemById(row._id));

        function Delete() {
            // dispatch(crud.currentAction("delete", item));
            // modal.open();
        }
        return (
            <Menu style={{ width: 130 }}>
                <Menu.Item key={`${uniqueId()}`} icon={<EyeOutlined />} onClick={() => showModal(row._id, false)}>

                    View
                </Menu.Item>

                <Menu.Item
                    key={`${uniqueId()}`}
                    icon={<DeleteOutlined />}
                    onClick={Delete}
                >
                    Delete
                </Menu.Item>
            </Menu>
        );
    }


    const handleOk = () => {
        setModalText('The modal will be closed after two seconds');
        setConfirmLoading(true);
        setTimeout(() => {
            setVisible(false);
            setConfirmLoading(false);
        }, 2000);
    };
    const handleCancelNote = () => {
        setIsModalVisible(false)
    }
    const handleCancel = (isEdit) => {
        
        
        if (isEdit) {
            
            

            setVisible(false);
        }
        else {
           
            
            setVisibleView(false);
        }
    };
    const showModalNote = ({ row }) => {
        setDeactiveData(row)
        setIsModalVisible(true)
    }
    const onSubmit = () => {
        dispatch(crud.update(entity, edit_id, form.getFieldValue()));
        dispatch(crud.list(entity, pagination.current));
        setVisible(false);
    }


    // const handelDataTableLoad = useCallback((pagination) => {
    //     dispatch(crud.list("user", pagination.current));
    //   }, []);

    useEffect(() => {
        if (isSuccess) {
            dispatch(crud.resetAction("update"));
            // dispatch(crud.list(entity));
        }
    }, [isSuccess]);
    useEffect(() => {
        dispatch(crud.list(entity));
    }, []);
    const config = {
        entity,
        panelTitle,
        dataTableTitle,
        ENTITY_NAME,
        CREATE_ENTITY,
        ADD_NEW_ENTITY,
        UPDATE_ENTITY,
        DATATABLE_TITLE,
        readColumns,
        dataTableColumns,
        searchConfig,
        entityDisplayLabels,
    };
    let [category, setCategory] = useState([]);
    useEffect(() => {
        axios(`${API_BASE_URL}category/getParent`)
            .then(res => {
                setCategory(res.data.data)
            })
            .catch(err => {
             
                
            })
    }, []);
    const showModal = (id, isEdit) => {

        axios(`${API_BASE_URL}${entity}/read/${id}`)
            .then(res => {
                setData(res.data.result)
                setVisibleView(true);
                setLoadFormView(false)
            })
            .catch(err => {
             
                
            })
    };
    function onChange({ target: { value } }) {
        setNote(value)
    };

    return (
        <>
            <Modal title="Please Define the Reason" visible={isModalVisible} onOk={disApprove} onCancel={handleCancelNote}>
                <TextArea
                    value={note}
                    onChange={onChange}
                    autoSize={{ minRows: 3, maxRows: 5 }}
                />
            </Modal>
            <Modal
                title="View Listing Request"
                visible={visibleView}
                onOk={handleOk}
                confirmLoading={confirmLoadingView}
                onCancel={() => {
                    handleCancel(false)
                }}
                footer={[]}
            >
                <Loading isLoading={loadFormView}>
                    <ul>
                        <li>User Name {data.user_id && data.user_id.fname ? data.user_id.fname : ""}</li>
                        <li>Category One Name  {data.category_id_one ? data.category_id_one.name : ""}</li>
                        <li>Category Two Name  {data.category_id_two != null ? data.category_id_two.name : ""}</li>
                        <li>Category there Name  {data.category_id_three != null ? category_id_three : ""}</li>
                        <li>Approval Status {data.status ? "Approve" : "Disapprove"}</li>
                    </ul>
                </Loading>
            </Modal>
            <HeaderContent />
            <PageHeader
                onBack={() => window.history.back()}
                title={dataTableTitle}
                ghost={false}

                style={{
                    padding: "20px 10px",
                }}
            ></PageHeader>

            <div className="table" style={{ padding: "20px" }}>

                {/* <SearchItem config={config} /> */}
                <Loading isLoading={isLoading}>
                    <Table
                        columns={dataTableColumns}
                        rowKey={(item) => item._id}
                        dataSource={items}
                        pagination={pagination}
                        // loading={listIsLoading}
                        onChange={handelDataTableLoad}
                        scroll={{ x: 1500 }}
                    />
                </Loading>
            </div>
        </>
    );
}

export default ListingRequest;
